import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import Clipboard from 'clipboard';
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { Component } from '@wordpress/element';
/**
 * Internal dependencies
 */

import IconButton from '../icon-button';
import Button from '../button';

var ClipboardButton =
/*#__PURE__*/
function (_Component) {
  _inherits(ClipboardButton, _Component);

  function ClipboardButton() {
    var _this;

    _classCallCheck(this, ClipboardButton);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ClipboardButton).apply(this, arguments));
    _this.bindContainer = _this.bindContainer.bind(_assertThisInitialized(_this));
    _this.onCopy = _this.onCopy.bind(_assertThisInitialized(_this));
    _this.getText = _this.getText.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ClipboardButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var container = this.container,
          getText = this.getText,
          onCopy = this.onCopy;
      var button = container.firstChild;
      this.clipboard = new Clipboard(button, {
        text: getText,
        container: container
      });
      this.clipboard.on('success', onCopy);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clipboard.destroy();
      delete this.clipboard;
      clearTimeout(this.onCopyTimeout);
    }
  }, {
    key: "bindContainer",
    value: function bindContainer(container) {
      this.container = container;
    }
  }, {
    key: "onCopy",
    value: function onCopy(args) {
      // Clearing selection will move focus back to the triggering button,
      // ensuring that it is not reset to the body, and further that it is
      // kept within the rendered node.
      args.clearSelection();
      var _this$props = this.props,
          onCopy = _this$props.onCopy,
          onFinishCopy = _this$props.onFinishCopy;

      if (onCopy) {
        onCopy(); // For convenience and consistency, ClipboardButton offers to call
        // a secondary callback with delay. This is useful to reset
        // consumers' state, e.g. to revert a label from "Copied" to
        // "Copy".

        if (onFinishCopy) {
          clearTimeout(this.onCopyTimeout);
          this.onCopyTimeout = setTimeout(onFinishCopy, 4000);
        }
      }
    }
  }, {
    key: "getText",
    value: function getText() {
      var text = this.props.text;

      if ('function' === typeof text) {
        text = text();
      }

      return text;
    }
  }, {
    key: "render",
    value: function render() {
      // Disable reason: Exclude from spread props passed to Button
      // eslint-disable-next-line no-unused-vars
      var _this$props2 = this.props,
          className = _this$props2.className,
          children = _this$props2.children,
          onCopy = _this$props2.onCopy,
          onFinishCopy = _this$props2.onFinishCopy,
          text = _this$props2.text,
          buttonProps = _objectWithoutProperties(_this$props2, ["className", "children", "onCopy", "onFinishCopy", "text"]);

      var icon = buttonProps.icon;
      var classes = classnames('components-clipboard-button', className);
      var ComponentToUse = icon ? IconButton : Button; // Workaround for inconsistent behavior in Safari, where <textarea> is not
      // the document.activeElement at the moment when the copy event fires.
      // This causes documentHasSelection() in the copy-handler component to
      // mistakenly override the ClipboardButton, and copy a serialized string
      // of the current block instead.

      var focusOnCopyEventTarget = function focusOnCopyEventTarget(event) {
        event.target.focus();
      };

      return createElement("span", {
        ref: this.bindContainer,
        onCopy: focusOnCopyEventTarget
      }, createElement(ComponentToUse, _extends({}, buttonProps, {
        className: classes
      }), children));
    }
  }]);

  return ClipboardButton;
}(Component);

export default ClipboardButton;
//# sourceMappingURL=index.js.map